import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import ToolsPage from './pages/ToolsPage';
import { AppStateProvider } from './state/AppStateProvider';
import { ToastProvider } from './state/ToastProvider';
import './App.css';

function App() {
  return (
    <Router>
      <AppStateProvider>
        <ToastProvider>
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<Navigate to="/tools/compound" replace />} />
              <Route path="tools">
                <Route index element={<Navigate to="/tools/compound" replace />} />
                <Route path=":toolId" element={<ToolsPage />} />
              </Route>
            </Route>
          </Routes>
        </ToastProvider>
      </AppStateProvider>
    </Router>
  );
}

export default App;
